import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: '.temp-view-card',
  templateUrl: './temp-view-card.component.html',
  styleUrls: ['./temp-view-card.component.scss']
})
export class TempViewCardComponent implements OnInit {

  constructor() { }

  @Input() cardData: any;

  @Input() cardType: any;
  ngOnInit() {
    // console.log(this.cardType);
    if (this.cardType === 'listicle' || this.cardType === 'liveblog') {
      this.cardData = JSON.parse(this.cardData);
    }
  }

}
